<ng-container *ngIf="route">
    <div class="infopackage">
        <div class="package">
            <div class="prompt">{{ 'TRUCKING.ROUTE.ROUTEKEY.CAPTION' | translate}}</div>
            <shared-copyclipboard *ngIf="route.routeKey" class="packageKey" [value]="route.routeKey">{{route.routeKey}}
            </shared-copyclipboard>
        </div>
        <div class="package" *ngIf="route.title">
            <div class="prompt">{{ 'TRUCKING.ROUTE.CUSTOMERREFERENCE.CAPTION' | translate}}</div>
            <shared-copyclipboard *ngIf="route.title" class="packageKey" [value]="route.title">{{route.title}}
            </shared-copyclipboard>
        </div>
    </div>
    <div class="line ellipsis" *ngIf="route.line1">
        <div class="prompt">{{ 'TRUCKING.ROUTE.DATES.CAPTION' | translate}} </div>
        <div class="value">{{ route.dateHourFrom | datehournosecondsnotzobserver }} - {{ route.dateHourTo |
            datehournosecondsnotzobserver }}</div>
    </div>
    <div class="bottom-zone">
        <shared-trucking-route-strip-card-component [route]="route"></shared-trucking-route-strip-card-component>
    </div>
</ng-container>